module.exports = __webpack_public_path__ + "img/activity_1_2.c59bf3d3.jpg";